export const color = {
  primary: {
    darkest: "",
    darker: "#E26E04",
    hover: "#bf610a",
    base: "#EF790C",
    light: "",
    lighter: "",
    lightest: ""
  },
  secondary: {
    darkest: "",
    darker: "",
    hover: "",
    base: "",
    light: "",
    lighter: "",
    lightest: ""
  },
  gray: {
    alt: "#DDDDDD",
    darkest: "#1F1F1F",
    darker: "#797979",
    dark: "#CFCFCF",
    base: "#ECECEC",
    light: "#f7f7f7",
    lighter: "#F6F6F6",
    lightest: "#F1F1F1",
    white: "#FFFFFF",
    black: ""
  },
  body: { base: "#ffffff" },
  base: { base: "#606060" },
  black: { base: "#1f1f1f", alt: "#4A4A4A" }
};
export const font = {
  family: {
    base: "Merriweather Webfont",
    head: "Source Sans Pro Webfont",
    alt: "DIN Alternate Webfont"
  },
  base: "16px",
  small: "14px",
  xsmall: "12px",
  large: "18px",
  xlarge: "20px",
  xxlarge: "22px",
  xxxlarge: "24px"
};
